import client from './client';

/* ── baseURL is already https://deltadesk.in/api
   so path here is just /dashboard/orders
   Final URL → https://deltadesk.in/api/dashboard/orders  ── */

export const getOrders = (params = {}) =>
  client.get('/dashboard/orders', { params });